import React from 'react';

const LoadingCircle = ({
  size = '65',
  viewBox,
  color = '#FFDC0D',
  opacity = '.3',
  tailwindClasses = '',
}) => {
  return (
    <svg
      className={tailwindClasses}
      width={size}
      height={size}
      viewBox={viewBox || `0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 65C50.45 65 65 50.45 65 32.5S50.45 0 32.5 0 0 14.55 0 32.5 14.55 65 32.5 65zm0-8C46.031 57 57 46.031 57 32.5S46.031 8 32.5 8 8 18.969 8 32.5 18.969 57 32.5 57z"
        fill={color}
        fill-opacity={opacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 65C50.45 65 65 50.45 65 32.5S50.45 0 32.5 0 0 14.55 0 32.5 14.55 65 32.5 65zm0-8C46.031 57 57 46.031 57 32.5S46.031 8 32.5 8 8 18.969 8 32.5 18.969 57 32.5 57z"
        fill={color}
        fill-opacity={opacity}
      />
      <path
        d="M38.84.624A32.5 32.5 0 0 1 55.481 9.52l-5.657 5.657A24.423 24.423 0 0 0 32.5 8C18.969 8 8 18.969 8 32.5S18.969 57 32.5 57c6.766 0 12.89-2.742 17.324-7.176l5.657 5.657A32.5 32.5 0 1 1 38.841.624z"
        fill={color}
      />
    </svg>
  );
};

export default LoadingCircle;
